import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routePurchaseOrderCreate,
  detail: routePurchaseOrderDetail,
  home: routePurchaseOrdersHome,
  root: routePurchaseOrdersRoot,
} = createDoctypeRoutes({
  createName: 'new-purchase-order',
  createPath: 'new-purchase-order',
  detailName: 'purchase-order-detail',
  doctype: DOCTYPES.PURCHASE_ORDER,
  homeName: 'purchase-orders-home',
  ifOwner: false,
  path: 'purchase-orders',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/purchaseOrder/AddPurchaseOrder.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/purchaseOrder/ViewPurchaseOrder.vue'),
    list: async () =>
      await import('@/components/viewsExternal/purchaseOrder/PurchaseOrderView.vue'),
  },
})

export {
  routePurchaseOrderCreate,
  routePurchaseOrderDetail,
  routePurchaseOrdersHome,
  routePurchaseOrdersRoot,
}
